<style lang="less" scoped>
@import url('../../../style/common/variable.less');
.center{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
  .expert{margin: 20px auto;display: flex;justify-content:space-between;}
  .expert_left{
    ul{list-style: none;margin: 0;padding: 0;}
    .imgTitleContent{text-align: left;}
  }
  // .el-button{width: 780px;font-size: 16px;background-image: linear-gradient(#ECFAFF, #ECF6FF);margin-top: 10px;}
  i{font-size: 19px;color: #289FDE;margin-right: 5px;}
  h3{line-height: 50px;text-align: left;margin:0;font-size: 18px;}
  .expert_rig{margin-right: 150px;
    .country{ position: relative;
      ul{list-style: none;margin: 0;padding: 0;}
      .left{position: absolute;left: 90px;top: -8px;
        li{margin: 7px auto;cursor: pointer;}
        img{width: 240px;height: 158px;}
      }
      .right{margin-left: 20px;text-align: left;position: absolute;left: 90px;top: -8px;
        li{width: 280px;height: 38px;border-bottom: 2px solid rgb(230, 228, 228);margin: 10px auto;cursor: pointer;}
        span{font-size: 18px;letter-spacing: 1px;}
        .zhuanjia{font-weight: 600;}
      }
    }
  }

@media screen and (min-width: @max-screen)
{
  .expert{width: 1200px}
  .el-button{width: 780px;font-size: 16px;background-image: linear-gradient(#ECFAFF, #ECF6FF);margin-top: 10px;}
}

@media screen and (max-width: @max-screen)
{
  .expert{width: 100%}
  .expert_left{width: 100%;}
  h3{margin-left: 5%;}
  .el-button{width: 100%;font-size: 16px;background-image: linear-gradient(#ECFAFF, #ECF6FF);margin-top: 10px;}
}
</style>

<template>
  <div class="center">
    <div class="expert">
      <div class="expert_left">
        <h3><i class="iconfont icon-fenlei_"></i>专家论矿 / Experts on Mining</h3>
        <ul>
          <li v-for="(item,index) in items" :key="index" >
            <ZJImgTitleContent class="imgTitleContent" :imgTitleContentItem="item" @handleClick="goDetails"></ZJImgTitleContent>
          </li>
        </ul>
        <el-button @click="getOthers" :disabled="moreLength <= 0">加载更多</el-button>
      </div>

      <div class="expert_rig" v-if="ifShowFlag">
        <h3 v-if="ifShowFlag"><i class="iconfont icon-zhuanjia"></i>专家列表 / List of experts</h3>
        <div class="country" v-if="ifShowFlag">
        
          <ul class="left">
            <li v-for="(item,index) in flagList" :key="index" @click="getExpertlist(item.value)">
              <img :src="item.flag" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ZJImgTitleContent from '../assembly/ZJImgTitleContent.vue'
export default {
  components: {ZJImgTitleContent},
  name: '',
  data()
  {
    return {
      temp: [],
      nameList: [],
      expertlist: [],
      num: null,
      items: [],
      moreLength: null,
      currentPage: 1,
      flagList: [
        {flag: 'static/images/zjzk/China.png',       namec: '中国',      namee: 'CHINA',       value: 2},
        {flag: 'static/images/zjzk/Malaysia.png',    namec: '马来西亚',   namee: 'MALAYSIA',   value: 4},
        {flag: 'static/images/zjzk/Indonesia.png',   namec: '印度尼西亚', namee: 'INDONESIA',   value: 3},
        {flag: 'static/images/zjzk/Thailand.png',    namec: '泰国',       namee: 'THAILAND',    value: 7},
        {flag: 'static/images/zjzk/Philippines.png', namec: '菲律宾',     namee: 'PHILIPPINES', value: 5},
        {flag: 'static/images/zjzk/Singapore.png',   namec: '新加坡',     namee: 'SINGAPORE',   value: 6},
        {flag: 'static/images/zjzk/Brunei.png',      namec: '文莱',       namee: 'BRUNEI',      value: 8},
        {flag: 'static/images/zjzk/Vietnam.png',     namec: '越南',      namee: 'VIETNAM',     value: 9},
        {flag: 'static/images/zjzk/Laos.png',        namec: '老挝',      namee: 'LAOS',        value: 10},
        {flag: 'static/images/zjzk/Myanmar.png',     namec: '缅甸',      namee: 'MYANMAR',     value: 11},
        {flag: 'static/images/zjzk/Cambodia.png',    namec: '柬埔寨',     namee: 'CAMBODIA',   value: 12}
      ],
      ifShowFlag: true
    }
  },
  created()
  {
    this.getdata()
    this.getExpertlist(2)
  },

  mounted()
  {
    if (window.innerWidth > 912)
      this.ifShowFlag = true
    else
      this.ifShowFlag = false
  },

  methods:
  {
    getdata(catid)
    {
      //获取列表数据
      let paras = {cmd: 'query', _major: 11, _minor: 45, _exp: 'id>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: `${this.currentPage}`, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        ret[0].data.forEach(item =>
        {
          arr.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, introduce: item.introduce, release: '发布时间', time: item.addtime, description: '关键词', value: item.tag})
        })
        this.imgTitleContentdata = arr
        this.moreLength = this.imgTitleContentdata.length
        // 初始化页面数据
        this.items = []
        if (this.imgTitleContentdata.length >= 10)
        {
          for (let i = 0; i < 10; i++)
          {
            this.items.push(this.imgTitleContentdata[i])
            this.moreLength -= 1
          }
        }
        else
        {
          for (let i = 0; i < this.imgTitleContentdata.length; i++)
          {
            this.items.push(this.imgTitleContentdata[i])
            this.moreLength -= 1
          }
        }
        this.num = 0
      })
    },
    getOthers()
    {
      this.currentPage++
      this.getdata()
    },
    /**
     * 获取专家列表
     */
    getExpertlist(num)
    {
      //获取作者名字
      let paras2 = {cmd: 'query', _major: 11, _minor: 28, _exp: `areaid=${num}`, orderby: 'id ASC', init: 0, pageno: 1, pagesize: 100}
      window.post.getPost(paras2).then(ret =>
      {
        this.nameList = []
        ret[0].data.forEach(item =>
        {
          this.nameList.push({id: item.id, truename: item.truename})
        })
      })
    },
    goZjDetails(item)
    {
      let url = this.$router.resolve({path: '/ZjDetails', query: { id: item.id }})
      window.open(url.href, '_blank')
    },
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/ZhikuDetails', query: { id: item.id }})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Thinktank.vue